
export default {
  validate(value) {
    return new RegExp(/^\d+(\.\d+)?$/g).test(value);
  },
  message: 'El campo {_field_} debe contener un monto válido',
};
